import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { SummaryTitleStyled } from '../SummaryTitleStyled';
import { rem } from 'polished';

export const SummaryTitleAC = styled(SummaryTitleStyled)`
    h3 {
        font-size: ${rem('34px')};
        color: ${({ theme }) => theme.colors.grey5};

        @media (max-width: ${breakpoints.xs}px) {
            font-size: ${rem('26px')};
        }
    }

    p {
        margin: ${rem('12px')} 0 ${rem('29px')};
        font-size: ${rem('20px')};
        color: ${({ theme }) => theme.colors.black};

        @media (max-width: ${breakpoints.xs}px) {
            font-size: ${rem('16px')};
            margin-top: ${rem('10px')};
        }
    }
`;
